import RepositoryService from 'src/services/repository'

const resource = 'role'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
}
